module.exports = __webpack_public_path__ + "img/wallet.3f27e881.png";